export const EXPIRE_TIME = 900000; //15 min
export const LOCAL_MODE = false;
export const LOCAL_IP = "ws://192.168.2.109:8887";
export const LOCAL_IP_2 = "ws://192.168.2.109:6655";